import { Injectable } from '@angular/core';
import { ArcAngelPapiService } from './arc-angel-papi.service';
import { ArcAngelTincanService } from './arc-angel-tincan.service';
import { IllumLiveService } from './illum-live.service';
import { OrganizationUtilService } from './organization-util.service';

@Injectable({
  providedIn: 'root',
})
export class ArcAngelService {
  data: any;
  ArcliveActions: any;
  private myService: any;

  constructor(
    private arcAngelPapiService: ArcAngelPapiService,
    private arcAngelTincanService: ArcAngelTincanService,
    private illumLiveService:IllumLiveService,
    private orgutil:OrganizationUtilService,
  ) {
    this.myService = this.arcAngelPapiService;
    this.data = this.arcAngelPapiService.assignData(
      this.arcAngelTincanService.data
    );
    this.ArcliveActions = this.myService.ArcliveActions;
  }

  startForeverPoller() {
    return this.myService.methods.startForeverPoller();
  }
  stopForeverPoller() {
    this.myService.methods.stopForeverPoller();
  }
  orgIsHP() {
    return this.myService.methods.orgIsHP();
  }
  hasDemoFunction() {
    return this.myService.methods.hasDemoFunction();
  }
  showNonBuildingPerimeters() {
    this.myService.methods.showNonBuildingPerimeters();
  }
  hideNonBuildingPerimeters() {
    this.myService.methods.hideNonBuildingPerimeters();
  }
  clearPerimeters() {
    this.myService.methods.clearPerimeters();
  }
  get3dFacility(id: any) {
    return this.myService.methods.get3dFacility(id);
  }
  showBuildings() {
    this.myService.methods.showBuildings();
  }
  showOnlyMyBuilding(buildingId: any) {
    this.myService.methods.showOnlyMyBuilding(buildingId);
  }
  setBuildingIncident(incident: any) {
    this.arcAngelPapiService.setBuildingIncident(incident);
  }
 getAffectedPerimeterEntities(affectedPerimeters: any) {
    return this.orgutil.getAffectedPerimeterEntities(
      affectedPerimeters
    );
  }
 
  getPerimeter(perimeterId: any) {
    return this.myService.methods.getPerimeter(perimeterId);
  }
  getArea(areaId: any) {
    return this.myService.methods.getArea(areaId);
  }
  createAttachmentUrl(fileExtension: any, fileType: any) {
    return this.myService.methods.createAttachmentUrl(fileExtension, fileType);
  }
  putDataInS3(signeds3Url: any, dataToUpload: any, fileType: any) {
    return this.myService.methods.putDataInS3(
      signeds3Url,
      dataToUpload,
      fileType
    );
  }
  createUpdate(
    eventId: any,
    description: any,
    lat: any,
    lon: any,
    attachment: any,
    perimeterId: any
  ) {
    return this.myService.methods.createUpdate(
      eventId,
      description,
      lat,
      lon,
      attachment,
      perimeterId
    );
  }
  createNotification(
    profileIds: any,
    sendingOrg: any,
    title: any,
    body: any,
    attachments: any,
    data: any,
    sms: any,
    email: any
  ) {
    return this.myService.methods.createNotification(
      profileIds,
      sendingOrg,
      title,
      body,
      attachments,
      data,
      sms,
      email
    );
  }
  createSafeZone(
    eventId: any,
    name: any,
    description: any,
    lat: any,
    lon: any
  ) {
    return this.myService.methods.createSafeZone(
      eventId,
      name,
      description,
      lat,
      lon
    );
  }
  updateStatusOfEvent(eventId: any, status: any) {
    return this.myService.methods.updateStatusOfEvent(eventId, status);
  }
  updateEventDetails(
    obj: any,
    name: any,
    description: any,
    status: any,
    medGeo: any,
    lowGeo: any
  ) {
    return this.illumLiveService.updateEventDetails(
      obj,
      name,
      description,
      status,
      medGeo,
      lowGeo
    );
  }
  deleteEvent(eventId: any) {
    return this.myService.methods.deleteEvent(eventId);
  }
  updateSafeZone(
    eventId: any,
    safezoneId: any,
    name: any,
    description: any,
    isActive: any,
    lat: any,
    lon: any
  ) {
    return this.myService.methods.updateSafeZone(
      eventId,
      safezoneId,
      name,
      description,
      isActive,
      lat,
      lon
    );
  }
  activateSafezone(eventId: any, safezoneId: any) {
    return this.myService.methods.activateSafezone(eventId, safezoneId);
  }
  deactivateSafezone(eventId: any, safezoneId: any) {
    return this.myService.methods.deactivateSafezone(eventId, safezoneId);
  }
  deleteSafeZone(eventId: any, safezoneId: any) {
    return this.myService.methods.deleteSafeZone(eventId, safezoneId);
  }
  updateEventUpdate(
    eventId: any,
    updateId: any,
    description: any,
    isPublic: any
  ) {
    return this.myService.methods.updateEventUpdate(
      eventId,
      updateId,
      description,
      isPublic
    );
  }
  updateProcallToOpen(procallId: any) {
    return this.myService.methods.updateProcallToOpen(procallId);
  }
  updateProcallToResolved(procallId: any, profileId: any) {
    return this.myService.methods.updateProcallToResolved(procallId, profileId);
  }
  createIncidentFromPerimeter(
    orgId: any,
    perimeterId: any,
    label: any,
    description: any,
    includeFloors: any,
    focalPoint: any
  ) {
    return this.myService.methods.createIncidentFromPerimeter(
      orgId,
      perimeterId,
      label,
      description,
      includeFloors,
      focalPoint
    );
  }
  createIncident(
    locations: any,
    label: any,
    description: any,
    orgId: any,
    focalPoint: any,
    setIsPublic: any,
    setIsMuster: any
  ) {
    return this.myService.methods.createIncident(
      locations,
      label,
      description,
      orgId,
      focalPoint,
      setIsPublic,
      setIsMuster
    );
  }
  createGeofence(
    locations: any,
    label: any,
    description: any,
    orgId: any,
    profileId: any,
    incidentId: any
  ) {
    return this.myService.methods.createGeofence(
      locations,
      label,
      description,
      orgId,
      profileId,
      incidentId
    );
  }
  closeGeofence(geofence: any) {
    this.myService.methods.closeGeofence(geofence);
  }
  activateIncident(eventId: any) {
    return this.myService.methods.activateIncident(eventId);
  }
  getMyName() {
    return this.myService.methods.getMyName();
  }
  //getUserPermissionsAndOrgIds() { return this.arcAngelPapiService.getUserPermissionsAndOrgIds(); }
  getIncident(eventId: any) {
    return this.myService.methods.getIncident(eventId);
  }
  getAllIncidents(statuses: any) {
    return this.myService.methods.getAllIncidents(statuses);
  }
  getAllIncidentsByOrg(orgId: any, statuses: any) {
    return this.myService.methods.getAllIncidentsByOrg(orgId, statuses);
  }
  getProcall(procallId: any) {
    return this.myService.methods.getProcall(procallId);
  }
  getAllProcalls(getResolved: any) {
    return this.myService.methods.getAllProcalls(getResolved);
  }
  getCurrentCalendarEvents() {
    return this.myService.methods.getCurrentCalendarEvents();
  }
  getCurrentActiveTrackingEvents() {
    return this.myService.methods.getCurrentActiveTrackingEvents();
  }
  getAllActiveTrackingEvents() {
    return this.myService.methods.getAllActiveTrackingEvents();
  }
  getTrackingEvent(eventId: any) {
    return this.myService.methods.getTrackingEvent(eventId);
  }
  resolveTrackingEvent(eventId: any) {
    return this.myService.methods.resolveTrackingEvent(eventId);
  }
  addTrackingNote(eventId: any, note: any) {
    return this.myService.methods.addTrackingNote(eventId, note);
  }
  addCalendarNote(eventId: any, note: any) {
    return this.myService.methods.addCalendarNote(eventId, note);
  }
  getMissedCalendarEvents() {
    return this.myService.methods.getMissedCalendarEvents();
  }
  getArchivedCalendarEvents() {
    return this.myService.methods.getArchivedCalendarEvents();
  }
  getCalendarEvent(calendarEventId: any) {
    return this.myService.methods.getCalendarEvent(calendarEventId);
  }
  resolveCalendarEvent(calendarEventId: any) {
    this.myService.methods.resolveCalendarEvent(calendarEventId);
  }
  getPlaybackIncident(eventId: any) {
    return this.myService.methods.getPlaybackIncident(eventId);
  }
  getPlaybackProcall(eventId: any) {
    return this.myService.methods.getPlaybackProcall(eventId);
  }
  getPlaybackUserLocations(profileId: any, start: any, end: any) {
    return this.myService.methods.getPlaybackUserLocations(
      profileId,
      start,
      end
    );
  }
  approveIncidentUpdate(eventId: any, updatedata: any) {
    return this.illumLiveService.approveIncidentUpdate(eventId, updatedata);
  }
  rejectIncidentUpdate(eventId: any, updatedata: any) {
    return this.illumLiveService.rejectIncidentUpdate(eventId, updatedata);
  }
  publicizeIncidentUpdate(eventId: any, updatedata: any) {
    return this.illumLiveService.publicizeIncidentUpdate(eventId, updatedata);
  }
  privitizeIncidentUpdate(eventId: any, updatedata: any) {
    return this.illumLiveService.privitizeIncidentUpdate(eventId, updatedata);
  }
  changePassword(oldPassword: any, newPassword: any) {
    return this.myService.methods.changePassword(oldPassword, newPassword);
  }
  verifyPIN(PIN: any) {
    return this.myService.methods.verifyPIN(PIN);
  }
  changePin(oldPincode: any, newPincode: any) {
    return this.myService.methods.changePin(oldPincode, newPincode);
  }
  forgotPin(email: any) {
    return this.myService.methods.forgotPin(email);
  }
  forgotPassword(email: any) {
    return this.myService.methods.forgotPassword(email);
  }
  resetPassword(
    email: any,
    verificationCode: any,
    password: any,
    verifyPassword: any
  ) {
    return this.myService.methods.resetPassword(
      email,
      verificationCode,
      password,
      verifyPassword
    );
  }
  resetPin(email: any, verificationCode: any, pin: any, verifyPin: any) {
    return this.myService.methods.resetPin(
      email,
      verificationCode,
      pin,
      verifyPin
    );
  }
  getPerimeterFromAPI(orgId: any, perimeterId: any) {
    return this.myService.methods.getPerimeterFromAPI(orgId, perimeterId);
  }
  establishIncidentOrgForLiveMode(incidentId: any) {
    return this.illumLiveService.establishIncidentOrgForLiveMode(incidentId);
  }
  getArcliveActions() {
    return this.myService.getArcliveActions();
  }
  resetManagingOrgId() {
    return this.myService.methods.resetManagingOrgId();
  }
  getFloorplanFile(floorplanId: any) {
    return this.myService.methods.getFloorplanFile(floorplanId);
  }
  getAllIncidentsForPlaybackTree() {
    return this.myService.methods.getAllIncidentsForPlaybackTree();
  }
  getAllProcallsForPlaybackTree() {
    return this.myService.methods.getAllProcallsForPlaybackTree();
  }
  canCreateIncident() {
    return this.myService.methods.canCreateIncident();
  }
  getAllActiveTrackingEventsForPlaybackTree() {
    return this.myService.methods.getAllActiveTrackingEventsForPlaybackTree();
  }
  runChooseOrgDialog(orgIds: any, title: any) {
    return this.myService.methods.runChooseOrgDialog(orgIds, title);
  }
  setManagingOrgId(id: any) {
    return this.myService.methods.setManagingOrgId(id);
  }
  getOrgsAvailForIncident(id: any) {
    return this.myService.methods.getOrgsAvailForIncident(id);
  }
  getTwilioOrgs() {
    return this.illumLiveService.getTwilioOrgs();
  }
  getUserStatusByPerimeter(id: any) {
    return this.myService.methods.getUserStatusByPerimeter(id);
  }
  updatePerimeterSafetyStatus(id: any, timestamp: any) {
    return this.illumLiveService.updatePerimeterSafetyStatus(id, timestamp);
  }
  getIncidentDeviceDataByDeviceId(user: any, incidentId: any) {
    return this.myService.methods.getIncidentDeviceDataByDeviceId(
      user,
      incidentId
    );
  }
  getIncidentDeviceHistoryDataByDeviceId(
    deviceId: any,
    incidentId: any,
    time: any
  ) {
    return this.myService.methods.getIncidentDeviceHistoryDataByDeviceId(
      deviceId,
      incidentId,
      time
    );
  }
  getUserStatusByPerimeterForPlaybackSingle(id: any, timestamp: any) {
    return this.myService.methods.getUserStatusByPerimeterForPlaybackSingle(
      id,
      timestamp
    );
  }
  getUserStatusByPerimeterForPlaybackMulti(id: any, timestamp: any) {
    return this.illumLiveService.getUserStatusByPerimeterForPlaybackMulti(
      id,
      timestamp
    );
  }
  getClosestTimestamp(timestamp: any) {
    return this.myService.methods.getClosestTimestamp(timestamp);
  }
  bulkUpdateDevices(time: any) {
    return this.myService.methods.bulkUpdateDevices(time);
  }
}
